import React from 'react';
import {Button, Text, Title} from '@priority-software/priority-style-react';
import texts from '../../texts';
import {Message} from '../../types';
import styles from './styles.module.scss';
import {ReactComponent as ErrorImg} from './errorOnboarding.svg';

type Props = {
    handler?: () => void;
    messageData?: Message;
    clearMessage?: () => void;
};

export const ErrorScreen = ({handler, messageData, clearMessage}: Props) => {
    const isOffline = !navigator.onLine;

    const msgText = messageData?.message?.Text;

    return (
        <div className={styles.component}>
            <ErrorImg />
            <Title
                skin="h2"
                text={isOffline ? texts.connection_error : texts.general_error_title}
                textColor="primary-700"
            />
            {msgText && !isOffline && (
                <Text
                    componentClasses={styles.description}
                    skin="paragraph-1"
                    tag="p"
                    textColor="primary-700"
                    fontWeight="normal"
                >
                    {msgText}
                </Text>
            )}
            {handler && !isOffline && (
                <Button
                    size="medium"
                    skin="primary"
                    componentClasses={styles.btn}
                    onClick={handler}
                >
                    {texts.general_error_btn_label}
                </Button>
            )}
        </div>
    );
};
